// extracted by mini-css-extract-plugin
export var alt = "SearchResult-module--alt--79eb0";
export var desktopOnly = "SearchResult-module--desktopOnly--e5d42";
export var displaySwitch = "SearchResult-module--displaySwitch--89dbc";
export var emptyHotelsRow = "SearchResult-module--emptyHotelsRow--f5bf5";
export var filtersWrapper = "SearchResult-module--filters-wrapper--343de";
export var main = "SearchResult-module--main--ec242";
export var mobileFilterToggle = "SearchResult-module--mobileFilterToggle--fa6e0";
export var mobileOnly = "SearchResult-module--mobileOnly--8f95f";
export var searchContainer = "SearchResult-module--searchContainer--e3eb7";
export var textLeft = "SearchResult-module--textLeft--2f454";
export var visuallyHidden = "SearchResult-module--visuallyHidden--f762c";